import { render, staticRenderFns } from "./FreedomDiscount.vue?vue&type=template&id=553588ba&scoped=true&"
import script from "./FreedomDiscount.vue?vue&type=script&lang=js&"
export * from "./FreedomDiscount.vue?vue&type=script&lang=js&"
import style0 from "./FreedomDiscount.vue?vue&type=style&index=0&id=553588ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553588ba",
  null
  
)

export default component.exports